import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { createEffect } from '@ngrx/effects';
import { filter, map, pairwise } from 'rxjs/operators';
import { ClearMapPositionAction } from './map.actions';

@Injectable()
export class MapEffects {
  constructor(private router: Router) {}

  public clearState$ = createEffect(() =>
    this.router.events.pipe(
      filter((event) => event instanceof NavigationStart),
      pairwise(),
      filter(([prevNavigation, currNavigation]: [NavigationStart, NavigationStart]) => {
        const fromHotelResults = prevNavigation.url.startsWith('/travel/hotel-results');
        const toHotelResults = currNavigation.url.startsWith('/travel/hotel-results');

        return !(fromHotelResults && toHotelResults);
      }),
      map(() => new ClearMapPositionAction('hotel-results-map'))
    )
  );
}
